var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class Product extends HTMLElement {
  _data;
  constructor(props) {
    super();
    props ? this._data = props : this._data = {};
  }
  render() {
    console.log(this._data);
  }
  connectedCallback() {
    console.log(this.getAttribute("product"));
  }
  static get observedAttributes() {
    return ["product"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this._datanewValue;
  }
}
window.customElements.define("product-data", Product);
function Observes(type) {
  function internal(target) {
    Object.defineProperty(target.constructor, "_keys", {
      get: function() {
        const defaults = new type();
        return Object.keys(defaults).map((s) => s.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase());
      },
      enumerable: false,
      configurable: false
    });
  }
  return internal;
}
class BaseComponent extends HTMLElement {
  static _keys;
  _data;
  constructor() {
    super();
    this._data = {};
  }
  get data() {
    return this._data;
  }
  static get observedAttributes() {
    return this.constructor._keys || [];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.data[name] = newValue;
    }
    this.render();
  }
}
class TimeProperties {
  datetime = "";
  year = "numeric";
  month = "numeric";
  day = "numeric";
  hour = "numeric";
  minute = "numeric";
  second = "numeric";
  timeZoneName = "short";
}
let TimeFormat = class extends BaseComponent {
  constructor() {
    super();
  }
  render() {
    let date = new Date(this.data.datetime || Date.now());
    this.innerHTML = new Intl.DateTimeFormat("default", {
      year: this.data.year || void 0,
      month: this.data.month || void 0,
      day: this.data.day || void 0,
      hour: this.data.hour || void 0,
      minute: this.data.minute || void 0,
      second: this.data.second || void 0,
      timeZoneName: this.data.timeZoneName || void 0
    }).format(date);
  }
  connectedCallback() {
    this.render();
  }
};
TimeFormat = __decorateClass([
  Observes(TimeProperties)
], TimeFormat);
customElements.define("time-format", TimeFormat);
